<template>
  <div class="c-cell c:row-between-center" @click="throttledOnClick">
    <div v-if="hasLeadingSlot" class="c-cell-leading">
      <slot name="leading" />
    </div>
    <div class="c-cell-content">
      <template v-if="hasTitleSlot"><slot name="title" /></template>
      <template v-else-if="hasDefaultSlot"><slot /></template>
      <div v-else class="c-cell-title">{{ title }}</div>
    </div>
    <div class="c-cell-tail">
      <div v-if="isLink" class="c-cell-link">
        <img src="@/assets/icons/link-more.svg" alt="" />
      </div>
      <div v-else class="c-cell-value">{{ value }}</div>
    </div>
  </div>
</template>

<script>
import { throttle } from "@/utils";

export default {
  props: {
    title: String,
    value: {
      type: String,
      default: "",
    },
    isLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasLeadingSlot() {
      return (
        typeof (this.$scopedSlots && this.$scopedSlots.leading) === "function"
      );
    },
    hasTitleSlot() {
      return (
        typeof (this.$scopedSlots && this.$scopedSlots.title) === "function"
      );
    },
    hasDefaultSlot() {
      return (
        typeof (this.$scopedSlots && this.$scopedSlots.default) === "function"
      );
    },
  },
  created() {
    this.throttledOnClick = throttle(this.onClick, 500);
  },
  methods: {
    onClick() {
      if (this.isLink) {
        this.$emit("click");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.c-cell {
  gap: 6/20rem;

  width: 100vw;
  height: 48/20rem;
  background-color: #fff;
  padding: 0 18/20rem;

  &-content {
    flex: 1;
    width: 0;
    height: auto;
  }

  &-title {
    height: 20/20rem;
    line-height: 20/20rem;
    font-size: 14/20rem;
    font-weight: 500;
    letter-spacing: 0;
  }

  &-tail {
    width: auto;
    height: auto;
  }

  &-link {
    width: 10/20rem;
    height: 10/20rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }

  &-value {
    height: 20/20rem;
    line-height: 20/20rem;
    text-align: right;
    font-size: 14/20rem;
    font-weight: 400;
    letter-spacing: 0;
    color: #b3b3b3;
  }
}
</style>
